import { IconCheckDefault, IconShieldCheck } from '@iwoca/icons';
import { Spinner } from '@iwoca/orion';

import styles from './LinkOpenBankingDocumentRequirementContentDE.module.css';
import { useOffersDE } from '../../../../hooks/useOffers/useOffersDE';
import { useSplitTestBranch } from '../../../../lendingApi/lendingApiQueries';

export const LinkOpenBankingDocumentRequirementContentDE = () => {
  const { splitTestBranch, isLoading, isError } = useSplitTestBranch(
    'de_open_banking_copy_test_2025_q3',
    {
      enabled: true,
    },
  );

  if (isLoading) return <Spinner />;
  if (isError) return <ExcludeBranchCopy />;

  if (splitTestBranch === 'INCLUDE') {
    return <IncludeBranchCopy />;
  }

  return <ExcludeBranchCopy />;
};

const IncludeBranchCopy = () => {
  const { offers } = useOffersDE();

  const suggestedAmount = offers?.find(
    (offer) => offer.is_suggested,
  )?.max_amount;

  const isAutoAmount = suggestedAmount && suggestedAmount <= 15000;

  return (
    <div>
      <div className={styles.headerContainer}>
        <h4>Mein Bankkonto verknüpfen</h4>
        <div className={styles.bankGradeEncryption}>
          <IconShieldCheck />
          <p className={styles.text}>Bankübliche Verschlüsselung</p>
        </div>
      </div>

      <div className={styles.benefitsContainer}>
        <IconWithText
          message={
            isAutoAmount
              ? 'Schnell – wir liefern Entscheidungen doppelt so schnell, als wenn Sie Ihre Kontoauszüge manuell hochladen.'
              : 'Schnell – wir liefern Entscheidungen schneller, als wenn Sie Ihre Kontoauszüge manuell hochladen.'
          }
        />
        <IconWithText message="Bevorzugt – die meisten unserer Kunden verknüpfen ihr Bankkonto." />
        <IconWithText
          message={
            <span>
              Sicher – Ihr Passwort wird niemals weitergegeben.{' '}
              <a
                href="https://www.iwoca.de/kredit/open-banking"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mehr erfahren
              </a>
            </span>
          }
        />
        <IconWithText message="Einfach – es sind nur ein paar Klicks nötig." />
      </div>

      <p className={styles.linkAllAccountsText}>
        Verknüpfen Sie alle Konten, die mehr als 10% Ihres Gesamtumsatzes
        ausmachen.
      </p>
    </div>
  );
};

const IconWithText = ({ message }: { message: React.ReactNode }) => {
  return (
    <div className={styles.iconWithText}>
      <IconCheckDefault />
      <p className={styles.text}>{message}</p>
    </div>
  );
};

const ExcludeBranchCopy = () => {
  return (
    <div data-testid="exclude-branch-copy">
      <h4>Mein Bankkonto verknüpfen</h4>
      <ul>
        <li>
          Open Banking ist ein sicherer Weg, Ihre Kontodaten zu teilen, ohne Ihr
          Passwort weiterzugeben.{' '}
          <a href="https://www.iwoca.de/kredit/open-banking">Mehr erfahren</a>
        </li>
        <li>
          Verknüpfen Sie alle Konten, die mehr als 10% Ihres Gesamtumsatzes
          ausmachen.
        </li>
      </ul>
    </div>
  );
};
